import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Loader } from '@/ui-kit/loader';
import { ROUTES } from '@/constants/routes';

const PrivateRoute = React.lazy(() => {
  return import('./private-route').then((module) => {
    return { default: module.PrivateRoute };
  });
});

const Booking = React.lazy(() => {
  return import('@/pages/booking').then((module) => {
    return { default: module.Booking };
  });
});

const BookingProducts = React.lazy(() => {
  return import('@/pages/booking/views/products').then((module) => {
    return { default: module.Products };
  });
});

const BookingTimeSlotDetails = React.lazy(() => {
  return import('@/pages/booking/views/time-slot-details').then((module) => {
    return { default: module.TimeSlotDetails };
  });
});

const BookingJobDetails = React.lazy(() => {
  return import('@/pages/booking/views/job-details').then((module) => {
    return { default: module.JobDetails };
  });
});

const Payment = React.lazy(() => {
  return import('@/pages/payment').then((module) => {
    return { default: module.Payment };
  });
});

const StripePaymentComplete = React.lazy(() => {
  return import('@/pages/payment/steps/stripe-payment-complete').then((module) => {
    return { default: module.StripePaymentComplete };
  });
});

const Requisites = React.lazy(() => {
  return import('@/pages/requisites').then((module) => {
    return { default: module.Requisites };
  });
});

const Meeting = React.lazy(() => {
  return import('@/pages/meeting').then((module) => {
    return { default: module.Meeting };
  });
});

const MeetingDetailsView = React.lazy(() => {
  return import('@/pages/meeting/views').then((module) => {
    return { default: module.DetailsView };
  });
});

const MeetingRescheduleView = React.lazy(() => {
  return import('@/pages/meeting/views').then((module) => {
    return { default: module.RescheduleView };
  });
});

const MeetingCancelView = React.lazy(() => {
  return import('@/pages/meeting/views').then((module) => {
    return { default: module.CancelView };
  });
});

const MeetingExpiredView = React.lazy(() => {
  return import('@/pages/meeting/views').then((module) => {
    return { default: module.ExpiredView };
  });
});

const MeetingBatch = React.lazy(() => {
  return import('@/pages/meeting-batch').then((module) => {
    return { default: module.MeetingBatch };
  });
});

const MeetingBatchDetailsView = React.lazy(() => {
  return import('@/pages/meeting-batch/views').then((module) => {
    return { default: module.DetailsView };
  });
});

const MeetingBatchRescheduleView = React.lazy(() => {
  return import('@/pages/meeting-batch/views').then((module) => {
    return { default: module.RescheduleView };
  });
});

const MeetingBatchCancelView = React.lazy(() => {
  return import('@/pages/meeting-batch/views').then((module) => {
    return { default: module.CancelView };
  });
});

const MeetingBatchExpiredView = React.lazy(() => {
  return import('@/pages/meeting-batch/views').then((module) => {
    return { default: module.ExpiredView };
  });
});

const BookingProductsDeprecated = React.lazy(() => {
  return import('@/pages/products-deprecated').then((module) => {
    return { default: module.ProductsDeprecated };
  });
});

const BookingTimeSlotsDeprecated = React.lazy(() => {
  return import('@/pages/time-slots-deprecated').then((module) => {
    return { default: module.TimeSlotsDeprecated };
  });
});

const PaymentDeprecated = React.lazy(() => {
  return import('@/pages/payment-deprecated').then((module) => {
    return { default: module.PaymentDeprecated };
  });
});

const DetailedMeetingDeprecated = React.lazy(() => {
  return import('@/pages/detailed-meeting-deprecated').then((module) => {
    return { default: module.DetailedMeetingDeprecated };
  });
});

const DetailedMeetingBatchDeprecated = React.lazy(() => {
  return import('@/pages/detailed-meeting-batch-deprecated').then((module) => {
    return { default: module.DetailedMeetingBatchDeprecated };
  });
});

const NotFound = React.lazy(() => {
  return import('@/pages/not-found').then((module) => {
    return { default: module.NotFound };
  });
});

export const Router = () => {
  return (
    <Routes>
      <Route
        path={ROUTES.BOOKING}
        element={(
          <Suspense fallback={<Loader fullScreen />}>
            <Booking />
          </Suspense>
        )}
      >
        <Route
          path={ROUTES.BOOKING_PRODUCTS}
          element={(
            <Suspense fallback={<Loader fullScreen />}>
              <BookingProducts />
            </Suspense>
          )}
        />

        <Route
          path={ROUTES.BOOKING_TIME_SLOT_DETAILS}
          element={(
            <Suspense fallback={<Loader fullScreen />}>
              <BookingTimeSlotDetails />
            </Suspense>
          )}
        />
        <Route
          path={ROUTES.BOOKING_JOB_DETAILS}
          element={(
            <Suspense fallback={<Loader fullScreen />}>
              <BookingJobDetails />
            </Suspense>
          )}
        />
      </Route>
      <Route
        path={ROUTES.PAYMENT}
        element={(
          <Suspense fallback={<Loader fullScreen />}>
            <Payment />
          </Suspense>
        )}
      />
      <Route
        path={ROUTES.STRIPE_PAYMENT_COMPLETE}
        element={(
          <Suspense fallback={<Loader fullScreen />}>
            <StripePaymentComplete />
          </Suspense>
        )}
      />
      <Route
        path={ROUTES.REQUISITES}
        element={(
          <Suspense fallback={<Loader fullScreen />}>
            <Requisites />
          </Suspense>
        )}
      />
      <Route
        path={ROUTES.MEETING}
        element={(
          <Suspense fallback={<Loader fullScreen />}>
            <PrivateRoute>
              <Suspense fallback={<Loader fullScreen />}>
                <Meeting />
              </Suspense>
            </PrivateRoute>
          </Suspense>
        )}
      >
        <Route
          path={ROUTES.DETAILED_MEETING}
          element={(
            <Suspense fallback={<Loader fullScreen />}>
              <MeetingDetailsView />
            </Suspense>
          )}
        />
        <Route
          path={ROUTES.MEETING_RESCHEDULE}
          element={(
            <Suspense fallback={<Loader fullScreen />}>
              <MeetingRescheduleView />
            </Suspense>
          )}
        />
        <Route
          path={ROUTES.MEETING_CANCEL}
          element={(
            <Suspense fallback={<Loader fullScreen />}>
              <MeetingCancelView />
            </Suspense>
          )}
        />
        <Route
          path={ROUTES.MEETING_EXPIRED}
          element={(
            <Suspense fallback={<Loader fullScreen />}>
              <MeetingExpiredView />
            </Suspense>
          )}
        />
      </Route>
      <Route
        path={ROUTES.MEETING_BATCH}
        element={(
          <Suspense fallback={<Loader fullScreen />}>
            <PrivateRoute>
              <Suspense fallback={<Loader fullScreen />}>
                <MeetingBatch />
              </Suspense>
            </PrivateRoute>
          </Suspense>
        )}
      >
        <Route
          path={ROUTES.DETAILED_MEETING_BATCH}
          element={(
            <Suspense fallback={<Loader fullScreen />}>
              <MeetingBatchDetailsView />
            </Suspense>
          )}
        />
        <Route
          path={ROUTES.MEETING_BATCH_RESCHEDULE}
          element={(
            <Suspense fallback={<Loader fullScreen />}>
              <MeetingBatchRescheduleView />
            </Suspense>
          )}
        />
        <Route
          path={ROUTES.MEETING_BATCH_CANCEL}
          element={(
            <Suspense fallback={<Loader fullScreen />}>
              <MeetingBatchCancelView />
            </Suspense>
          )}
        />
        <Route
          path={ROUTES.MEETING_BATCH_EXPIRED}
          element={(
            <Suspense fallback={<Loader fullScreen />}>
              <MeetingBatchExpiredView />
            </Suspense>
          )}
        />
      </Route>
      <Route
        path={ROUTES.BOOKING_PRODUCTS_DEPRECATED}
        element={(
          <Suspense fallback={<Loader fullScreen />}>
            <BookingProductsDeprecated />
          </Suspense>
        )}
      />
      <Route
        path={ROUTES.BOOKING_TIME_SLOTS_DEPRECATED}
        element={(
          <Suspense fallback={<Loader fullScreen />}>
            <BookingTimeSlotsDeprecated />
          </Suspense>
        )}
      />
      <Route
        path={ROUTES.PAYMENT_DEPRECATED}
        element={(
          <Suspense fallback={<Loader fullScreen />}>
            <PaymentDeprecated />
          </Suspense>
        )}
      />
      <Route
        path={ROUTES.DETAILED_MEETING_DEPRECATED}
        element={(
          <Suspense fallback={<Loader fullScreen />}>
            <DetailedMeetingDeprecated />
          </Suspense>
        )}
      />
      <Route
        path={ROUTES.DETAILED_MEETING_BATCH_DEPRECATED}
        element={(
          <Suspense fallback={<Loader fullScreen />}>
            <DetailedMeetingBatchDeprecated />
          </Suspense>
        )}
      />
      <Route
        path={ROUTES.NOT_FOUND}
        element={(
          <Suspense fallback={<Loader fullScreen />}>
            <NotFound />
          </Suspense>
        )}
      />
    </Routes>
  );
};
